import { useState, useEffect } from 'react';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { privateFetch } from '../../../../utils/apiHelper';
import PopUpItem from './PopUpItem';
import PageWrapper from '../../../../components/Display/PageWrapper';
import PopUpManager from './PopUpManager';
import styles from '../../../../components/Display/Wrapper.module.scss';

function PopUpPage({ isActive }) {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [popUp, setPopUp] = useState(undefined);
  const { accountContext } = useAccountContext();
  const [loading, setLoading] = useState(false);

  const fetchPopUp = async () => {
    await privateFetch('GET', 'maisonmousse', `/cu/${accountContext.id}/popup/`).then((res) => {
      setPopUp(res);
    });
  };

  useEffect(() => {
    fetchPopUp();
  }, []);

  console.log(popUp);

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const handleClickPopup = () => {
    setPanelIsOpen(true);
  };

  const newPopUpAction = {
    onClick: handleOpenManager,
    label: 'Ajouter une Pop-Up',
    icon: 'pi-plus'
  };

  const createPopUp = async (popUpForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'maisonmousse',
      `/cu/${accountContext.id}/popup/`,
      'Le PopUp a bien été ajouté',
      JSON.stringify(popUpForm)
    ).then(() => {
      fetchPopUp();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updatePopUp = async (popUpForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'maisonmousse',
      `/cu/${accountContext.id}/popup/${popUp.id}/`,
      'Le PopUp a bien été modifié',
      JSON.stringify(popUpForm)
    ).then(() => {
      fetchPopUp();
      setLoading(false);
      setPanelIsOpen(false);
    });
  };

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="PopUp"
        // labelAction={hand}
        actions={!popUp && [newPopUpAction]}>
        <div className={styles.pageContentContainer}>
          {popUp && <PopUpItem popup={popUp} handleClickPopup={handleClickPopup} />}
        </div>
        <PopUpManager
          isOpen={panelIsOpen}
          onClose={setPanelIsOpen}
          popup={popUp}
          onUpdate={updatePopUp}
          onCreate={createPopUp}
        />
      </PageWrapper>
    </div>
  );
}

export default PopUpPage;
